export default {
  props:{
    id: { type: String, default: null },
  },
  methods: {
    onMountedDataProvider() {
      return new Promise((resolve) =>{
        if(app.dataproviders[this.dataProvider]){
          this.data_provider_ref = app.dataproviders[this.dataProvider];
          this.data_provider_ref.registerComponent(this);
          this.onReady = true;
          resolve(true);
        }else{
          setTimeout(() => {
            this.data_provider_ref = app.dataproviders[this.dataProvider];
            this.data_provider_ref.registerComponent(this);
            this.onReady = true;
            resolve(true);
          }, 2000);
        }
      })
    }
  },
  data(){
    return{
      onReady: false,
      data_provider_ref: { l_record: {}, l_list: [], l_filters: {}, l_inputs: {}, l_files: [], l_page:0, l_totalRecords: 0, l_pageSize: 0 }
    }
  }
};
